import { Report } from "@app/analytics/MeetingReports/types";
import { toast } from "@app/common/hooks/useToasts";

import useUpdateSessionMetadata from "./useUpdateSessionMetadata";
import useEditTopicReport from "../topics/useEditTopicReport";

interface UpdateMeetingNameHandlers {
  onSettled?: () => void;
  onError?: () => void;
}
const useUpdateReportName = (
  report: Report,
  updateMeetingNameHandlers?: UpdateMeetingNameHandlers
) => {
  const { updateSessionMetadata } = useUpdateSessionMetadata();
  const { editTopicReportTitle } = useEditTopicReport({ context: "report" });

  const onError = () => {
    toast.error(
      "Error updating report title. Please refresh the page or try again later."
    );
    updateMeetingNameHandlers?.onError?.();
  };

  const onSettled = () => {
    updateMeetingNameHandlers?.onSettled?.();
  };

  const updateMeetingName = (title: string) =>
    updateSessionMetadata.mutate(
      { sessionId: report.id, title },
      {
        onError,
        onSettled,
      }
    );

  const updateTopicName = (title: string) =>
    editTopicReportTitle.mutate(
      { id: report.id, title },
      {
        onError,
        onSettled,
      }
    );
  return {
    updateMeetingName,
    updateTopicName,
    loadingMeeting: updateSessionMetadata.isPending,
    loadingTopic: editTopicReportTitle.isPending,
  };
};

export default useUpdateReportName;
